<div class="card {{ customClass }}" [ngClass]="{'is-collapsed': collapsed, 'active': !collapsed}">
  <ng-content></ng-content>
</div>